import type { ReactNode } from "react";

export function GroupHeader({ children }: { children: ReactNode }) {
  return (
    <div className="px-4 pt-1 pb-2 text-footnote uppercase tracking-[0.04em]" style={{ color: "var(--label-secondary)" }}>
      {children}
    </div>
  );
}

export function GroupFooter({ children }: { children: ReactNode }) {
  return (
    <div className="px-4 pt-2 text-footnote" style={{ color: "var(--label-secondary)" }}>
      {children}
    </div>
  );
}

export function Group({
  children,
  header,
  footer,
}: {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <section className="w-full">
      {header && <GroupHeader>{header}</GroupHeader>}
      <div
        className="overflow-hidden"
        style={{
          background: "var(--bg-grouped-secondary)",
          borderRadius: "var(--radius-group)",
        }}
      >
        {children}
      </div>
      {footer && <GroupFooter>{footer}</GroupFooter>}
    </section>
  );
}
